import * as React from 'react';
import { Dialog, Button } from '@mui/material';
import { withStyles } from '../../settings/styles';
import CloseIcon from '@mui/icons-material/CloseOutlined';

interface State {};

interface Props
{
    open: boolean;
    zIndex?: number;
    onClose: ()=>void;
}

class ViewerDialog extends React.Component<Props, State>
{
    // ============================================ //
    //               Member Variables               //
    // ============================================ //

    translation: any;

    // ============================================ //
    //               Routine Functions              //
    // ============================================ //

    constructor(props: any)
    {
        super(props);

        // Init State
        this.state = {
        };

        // Bind Renders
        this.renderDialog = this.renderDialog.bind(this);
    }

    // ============================================ //
    //               Render Functions               //
    // ============================================ //

    render()
    {
        return (<>
            {this.renderDialog()}
        </>);
    }

    // ============================================ //

    renderDialog()
    {
        let zIndex = this.props.zIndex ? this.props.zIndex : 10000;
        let close = this.props.onClose ? (
            <Button size="small" onClick={this.props.onClose} color="primary" style={{position: "absolute", right: 0, zIndex: zIndex+1}}>
                <CloseIcon/>
            </Button>
        ) : (<></>);

        return ( 
            <Dialog 
                onClose={this.props.onClose} 
                style={{zIndex: zIndex}} 
                PaperProps={{style: {overflowY: 'visible'}}}
                scroll={'body'}
                maxWidth={false}
                open={this.props.open}>
                   {close}
                   {this.props.children}
            </Dialog>
        );
    }

    // ============================================ //
}

// ----------------- Export -----------------  //

export default withStyles(ViewerDialog);

// ------------------------------------------  //